import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
export class loadControl{
    orbitControls;

    constructor() {

    }

    control(camera,renderer){
        this.orbitControls = new OrbitControls(camera,renderer.domElement);
        this.orbitControls.minPolarAngle = Math.PI/8;
        this.orbitControls.maxPolarAngle = Math.PI/2;
        this.orbitControls.enablePan = false;
        this.orbitControls.enableDamping = true;
        this.orbitControls.rotateSpeed = 1;


    }

    autoRotates(enable){
        if(enable){
            this.orbitControls.autoRotate = true;
            this.orbitControls.autoRotateSpeed = 5;
        }else {
            this.orbitControls.autoRotate = false;
        }

    }

    manualSplit(enable){
        this.orbitControls.enabled = enable;
    }

    getCamera() {
        return this.orbitControls.object;
    }

    controlUpdate(){
        this.orbitControls.update();
    }

}
